export default class AddSchedulePointController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    moment,
    SchedulePointService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.SchedulePointService = SchedulePointService;
    this.schedulePoint = {};
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  save(form) {
    if (form.$invalid) {
      return false;
    }

    this.schedulePoint.startTime = this.startTime;
    this.schedulePoint.endTime = this.endTime;
    this.SchedulePointService.add(this.schedulePoint)
      .then(() => {
        this.$mdDialog.hide();
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Pomyślnie dodano czynność.')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.newError({
            locals: {error}
          })
        );
      });
  }
}
